import React from 'react';
import { FlexBox, FLEX_DIRECTION } from '@monorepo/ui-kit';
import { classNameProp } from '@monorepo/type';
import ComponentsArray from '../../ComponentsArray';

type TColumnProps = {
  column: string[];
} & classNameProp;

const Column: Component<TColumnProps> = ({ column, className = '', components }) => (
  <FlexBox direction={FLEX_DIRECTION.column} className={className}>
    <ComponentsArray componentIds={column} components={components} />
  </FlexBox>
);

export default Column;
